module.exports = __webpack_public_path__ + "static/img/banner-bg.b5f8a5c3.png";